import { render } from "./subTopicManager.vue?vue&type=template&id=172a30d0&scoped=true"
import script from "./subTopicManager.vue?vue&type=script&lang=js"
export * from "./subTopicManager.vue?vue&type=script&lang=js"

import "./subTopicManager.vue?vue&type=style&index=0&id=172a30d0&scoped=true&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172a30d0"]])

export default __exports__